import { action, autorun, observable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import LeafletMap from '../../LeafletMap';
import { getCenter } from '../../Map/getCenterLatLng';
import Spinner from '../../Spinner';
import _ from 'lodash';
import * as api from '../../../actions/api';
import moment from 'moment';
import { getDisplayDate, utc } from '../../../libs/date';
import GraphView from '../../GraphView';

@inject('stationStore')
@observer
class RainfallGraph extends React.Component {

  @observable loading = false;
  @observable options = null;

  componentWillMount() {
    const { stationStore } = this.props;
    if (!stationStore.items.length && !stationStore.isLoading) stationStore.fetchItems();
    this.populateData();
  }

  populateData = () => {
    const { stationStore, params: { id } } = this.props;

    this.loading = true
    if (!stationStore.items.length) {
      setTimeout(() => {
        this.populateData();
      }, 500);
    } else {
      let filters = {
        stations: id,
        parameters: '61,62',
        date_from: moment().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
        date_to: moment().format('YYYY-MM-DDT23:59:59'),
      };
      api.analysis.fetchMore(filters).then(res => {
        let rh_10m = res[0].parameters.find(item => item.parameter_id === 61);
        let rh_1h = res[0].parameters.find(item => item.parameter_id === 62);
        let rh_acc = !!rh_1h && !!rh_1h.data ? rh_1h.data.reduce((acc, item, i) => {
          acc.push({
            time: item.time,
            value: i === 0 ? item.value : +item.value + +acc[i - 1].value,
          })
          return acc;
        }, []) : [];
        let options = {
          chart: {
            type: 'column',
            zoomType: 'x',
          },
          title: {
            text: stationStore.findById(id).name,
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              second: '%H:%M:%S',
            },
          },
          yAxis: {
            title: {
              text: 'Values',
            },
          },
          series: [{
            name: 'Rainfall 10M',
            data: !!rh_10m && !!rh_10m.data ? rh_10m.data.map(item => [getDisplayDate(item.time, { returnMills: true }), item.value]) : [],
            type: 'column'
          }, {
            name: 'Rainfall 1H',
            data: !!rh_1h && !!rh_1h.data ? rh_1h.data.map(item => [getDisplayDate(item.time, { returnMills: true }), item.value]) : [],
            type: 'column'
          }, {
            name: 'Rainfall Accumulated',
            data: !!rh_acc ? rh_acc.map(item => [getDisplayDate(item.time, { returnMills: true }), item.value]) : [],
            type: 'line'
          }],
        }
        this.options = options;
        this.loading = false;
      })
    }
  }

  render() {
    if (this.loading || !this.options) return <Spinner />
    let options = toJS(this.options)
    return <GraphView options={options} />
  }
}
export default RainfallGraph


// WEBPACK FOOTER //
// ./src/components/Analysis/Meteorological/RainfallGraph.js